import { connect } from 'react-redux';
import { actions as userActions } from '../../../redux/users';
import { hideComment, reportComment, unhideComment, featureComment, unfeatureComment, } from '../../redux/actionCreators';
import { isCommentReduxReady } from '../../redux/selectors';
var mapStateToProps = function (state) { return ({
    isCommentReduxReady: isCommentReduxReady(state),
}); };
var mapDispatchToProps = {
    onReportSpam: reportComment,
    onHide: hideComment,
    onUnhide: unhideComment,
    onFeature: featureComment,
    onUnfeature: unfeatureComment,
    onBlockUser: userActions.blockUser,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=ActionsMenu.container.js.map